// The token must be a dotted snake ("tag.field"): supplied-events rows lead
// with a count ("Scenario: 12 supplied events…"), which must never be
// mistaken for an entity to resolve or replace.
const LEADING_SNAKE = /^Scenario:\s*([\w-]+(?:\.[\w-]+)+)/i;

// The entity tag of the condition snake the description leads with (e.g. "spx.price" -> "spx").
export const scenarioEntityTag = (description: string): string | undefined => {
  const snake = description.match(LEADING_SNAKE)?.[1];
  return snake ? snake.split('.')[0] : undefined;
};

// Swap the raw leading "Scenario: <snake>" for the resolved human name.
export const formatScenarioDescription = (
  description: string,
  entityName?: string
): string => {
  if (!entityName || !LEADING_SNAKE.test(description)) {
    return description;
  }

  return description.replace(LEADING_SNAKE, () => entityName);
};
